<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="mail-box-header">
    <table class="table table-hover table-mail">
      <thead class="table-head">
        <tr>
          <th>DATAS</th>
          <th>DESCIÇÃO</th>
          <th>VALOR</th>
          <th>PAGAMENTO</th>
          <th>LABELS</th>
          <template v-if="transferMode">
            <th>ORIGEM</th>
            <th>DESTINO</th>
          </template>
          <th>PAGO?</th>
          <th v-if="!transferMode && permissionUpdate"></th>
          <th v-if="permissionDelete"></th>
          <button
            class="btn btn-outline add-button"
            @click="toggleForm"
            type="button"
            v-if="permissionCreate"
          >
            <i class="fa fa-plus"></i>
          </button>
        </tr>
      </thead>

      <tbody class="table-list">
        <tr v-if="showForm">
          <td colspan="8">
            <form class="form-content">
              <div class="row">
                <div
                  class="form-group col-md-8"
                  :class="{ 'col-md-6': transferMode }"
                >
                  <label>Descrição</label>
                  <input
                    type="text"
                    placeholder="Pagamento da conta de luz"
                    class="form-control"
                    v-model="form.description"
                  />
                </div>

                <div class="form-group col-md-3" v-if="transferMode">
                  <label>Conta</label>
                  <select class="form-control" v-model="form.account">
                    <option
                      v-for="(account, index) in accounts"
                      :key="index"
                      :value="account._id"
                    >
                      {{ account.name }}
                    </option>
                  </select>
                </div>

                <div>
                  <div
                    class="from-group col-md-4"
                    :class="{ 'col-md-3': transferMode }"
                  >
                    <label>Valor</label>
                    <input
                      v-model="form.amount"
                      type="number"
                      class="form-control"
                      step="0.01"
                      value="0.00"
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="from-group col-md-4">
                  <label>Label</label>
                  <tags-input
                    v-model="form.labels"
                    placeholder="Insira uma label"
                    :existing-tags="existentLabels"
                    :typeahead="true"
                    only-existing-tags
                  ></tags-input>
                </div>
                <!-- <div class="from-group col-md-3">
                  <label>Forma de pagamento</label>
                  <select class="form-control" v-model="form.paymentType">
                    <option
                      v-for="(item, index) in paymentsType"
                      :key="index"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div> -->
                <div class="form-group col-md-4">
                  <label>Vencimento</label>
                  <input
                    v-model="form.expiration"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-2" v-if="hasPaymentPermission">
                  <label>Pago?</label>

                  <switches
                    class="checkbox-content"
                    v-model="form.paid"
                    theme="bootstrap"
                    color="success"
                    :emit-on-mount="false"
                  ></switches>
                </div>
              </div>
              <button
                type="button"
                @click="addMovement"
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                v-if="!editMode"
              >
                <i class="fa fa-save"></i>
                Criar
              </button>
              <div v-else>
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  @click="exitEditMode"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  @click="updateMovement"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </td>
        </tr>
        <tr
          v-for="(movement, listIdx) in cashMovement"
          :key="listIdx"
          :class="[movement.type, { removed: movement.isRemoved }]"
        >
          <td>{{ movement.expiration | DateBR }}</td>
          <td>{{ movement.description }}</td>
          <td>{{ movement.amount | totalToCurrencyBR }}</td>
          <td>{{ paymentType(movement.paymentType) }}</td>
          <td>
            <div v-for="(label, index) in movement.labels" :key="index">
              <LabelInfo :label="label" />
            </div>
          </td>
          <template v-if="transferMode">
            <td>
              {{ movement.account.name }}
            </td>
            <td>
              {{ movement.transferredTo.name }}
            </td>
          </template>

          <td @click="changeMovementPaid(!movement.paid, movement)">
            <switches
              v-if="!movement.isRemoved && hasPaymentPermission"
              v-model="movement.paid"
              theme="bootstrap"
              color="success"
              :emit-on-mount="false"
            ></switches>
            <h3 v-else-if="!movement.isRemoved">
              {{ movement.paid ? 'Sim' : 'Não' }}
            </h3>
          </td>
          <td class="list-command" v-if="!transferMode && permissionUpdate">
            <button
              v-if="!movement.isRemoved"
              class="btn btn-outline"
              @click="enterEditMode(movement)"
              type="button"
            >
              <i class="fa fa-edit text-success"></i>
            </button>
          </td>
          <td class="list-command" v-if="permissionDelete">
            <button
              v-if="!movement.isRemoved"
              class="btn btn-outline"
              @click="removeMovemnt(movement._id)"
              type="button"
            >
              <i class="fa fa-trash text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Switches from 'vue-switches';
import LabelInfo from '../../../../components/labelInfo/LabelInfo';
import { addHours, format } from 'date-fns';

const actualHours = new Date().getHours() + 3;

const paymentsType = {
  CASH: {
    label: 'Dinheiro',
    value: 'cash',
  },
  CREDIT: {
    value: 'credit',
    label: 'Crédito',
  },
  DEBIT: {
    value: 'debit',
    label: 'Débito',
  },
};
export default {
  components: {
    LabelInfo,
    Switches,
  },
  props: {
    cashMovement: {
      default: Array,
    },
    transferMode: {
      default: false,
    },
    accountId: {
      default: '',
    },
  },
  data() {
    return {
      paymentsType: paymentsType,
      existentLabels: [],
      showForm: false,
      editMode: false,
      form: {
        amount: '',
        description: '',
        paymentType: paymentsType.CASH.value,
        account: '',
        expiration: format(new Date(), 'yyyy-MM-dd'),
        paid: true,
        labels: [],
      },
    };
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
  },
  mounted() {
    this.listAccounts();
    this.loadLabels();
  },
  computed: {
    total() {
      const total = this.cashMovement.reduce(
        (acc, item) => acc + item.amount,
        0,
      );
      return total;
    },
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'CREATE',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'DELETE',
      );
    },
    permissionPayExpense() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-expense',
        'UPDATE',
      );
    },
    permissionPayTransfer() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-transfer',
        'UPDATE',
      );
    },
    hasPaymentPermission() {
      if (this.transferMode) {
        return this.permissionPayTransfer;
      } else {
        return this.permissionPayExpense;
      }
    },
  },
  methods: {
    paymentType(type) {
      switch (type) {
        case 'cash': {
          return 'Dinheiro';
        }
        case 'credit': {
          return 'Crédito';
        }
        default:
          return 'Débito';
      }
    },
    async loadLabels() {
      const labels = await this.$store.dispatch('LABELS/All');
      const formattedLabels = labels.map(label => {
        return {
          key: label._id,
          value: label.title,
        };
      });
      this.existentLabels = formattedLabels;
    },
    async listAccounts() {
      try {
        const accounts = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAll',
        );
        this.accounts = accounts;
      } catch (error) {
        this.$toasted.error('Não foi possível listar as contas');
      }
    },
    toggleForm() {
      this.showForm = !this.showForm;
      this.editMode = false;
    },
    enterEditMode(movement) {
      this.showForm = true;
      this.editMode = movement._id;
      this.form.description = movement.description;
      this.form.amount = (movement.amount / 100).toFixed(2);
      this.form.paymentType = movement.paymentType;
      this.form.account = movement.account;
      this.form.expiration = format(
        new Date(movement.expiration),
        'yyyy-MM-dd',
      );
      this.form.paid = movement.paid;

      const formattedLabels = movement.labels
        ? this.existentLabels.filter(
            label =>
              movement.labels.findIndex(l => String(l) === String(label.key)) >=
              0,
          )
        : [];
      this.form.labels = formattedLabels;
    },
    formatLabel() {
      return this.form.labels.map(label => label.key);
    },
    exitEditMode() {
      this.editMode = false;
    },
    async updateMovement() {
      try {
        const payload = {
          ...this.form,
          amount: this.form.amount * 100,
          expiration: addHours(new Date(this.form.expiration), actualHours),
          employeeMovementType: this.transferMode
            ? 'reinforcement'
            : 'withdraw',
          account: this.transferMode ? this.form.account : this.accountId,
          type: this.transferMode ? 'tranfer' : 'expense',
          labels: this.formatLabel(),
        };
        if (this.transferMode) {
          payload.transferredTo = this.accountId;
        }

        await this.$store.dispatch('FINANCIAL-ACCOUNT/UpdateMovement', {
          payload,
          movementId: this.editMode,
        });
        this.$toasted.success('Movimento atualizado com sucesso');
        this.exitEditMode();
        this.$emit('refresh');
      } catch (error) {
        console.error(error);
        this.$toasted.error('Falha ao atualizar movimento');
      }
    },
    async addMovement() {
      try {
        const payload = {
          ...this.form,
          amount: this.form.amount * 100,
          expiration: addHours(new Date(this.form.expiration), actualHours),
          employeeMovementType: this.transferMode
            ? 'reinforcement'
            : 'withdraw',
          account: this.transferMode ? this.form.account : this.accountId,
          type: this.transferMode ? 'transfer' : 'expense',
          labels: this.formatLabel(),
        };
        if (this.transferMode) {
          payload.transferredTo = this.accountId;
        }
        if (!payload.account) {
          this.$toasted.error('A conta origem é obrigatória');
          return;
        }

        await this.$store.dispatch('FINANCIAL-ACCOUNT/CreateMovement', payload);

        this.$toasted.success('Movimento criado com sucesso');
        this.$emit('refresh');
      } catch (error) {
        this.$toasted.error('Falha ao criar movimento');
      }
    },
    async removeMovemnt(movementId) {
      try {
        confirm('Deseja excluir esse movimento?');

        await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/RemoveMovement',
          movementId,
        );
        this.$emit('refresh');
      } catch (error) {
        this.$toasted.error('Falha ao remover movimento');
      }
    },
    async changeMovementPaid(paid, movement) {
      try {
        if (movement.isRemoved || !this.hasPaymentPermission) {
          return;
        }
        const payload = {
          paid,
        };
        await this.$store.dispatch('FINANCIAL-ACCOUNT/SetMovementPaid', {
          payload,
          movementId: movement._id,
        });
        this.$emit('refresh');
      } catch (error) {
        this.$toasted.error('Falha ao atualizar status');
      }
    },
  },
};
</script>